import { createReducer } from '@reduxjs/toolkit';

import { FETCH_NEXT_MESSAGES, FETCH_NEXT_MESSAGES_SUCCESS, FETCH_NEXT_MESSAGES_FAILURE } from 'modules/chat/actionTypes';

/**
 * @typedef {boolean} IsLoadingNextMessagesState
 */

/** @type {IsLoadingNextMessagesState} */
const initialState = false;

const load = () => true;
const reset = () => false;

export default createReducer(initialState, (builder) => {
  builder
    .addCase(FETCH_NEXT_MESSAGES, load)
    .addCase(FETCH_NEXT_MESSAGES_SUCCESS, reset)
    .addCase(FETCH_NEXT_MESSAGES_FAILURE, reset);
});
